(() => {
  const LABEL_SELECTOR = 'label[for="field-EMzYQVejAY"]';
  const TRIGGER_CLASS = 'appointment-type-info__trigger';
  const TEMPLATE_ID = 'appointment-type-info-trigger-template';

  const placeTrigger = () => {
    const label = document.querySelector(LABEL_SELECTOR);
    const template = document.getElementById(TEMPLATE_ID);

    if (!label || !(template instanceof HTMLTemplateElement)) return false;
    if (label.querySelector(`.${TRIGGER_CLASS}`)) return true;

    const trigger = template.content.firstElementChild?.cloneNode(true);
    if (!(trigger instanceof HTMLElement)) return false;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const popup = document.getElementById('appointment-type-info');
      if (typeof popup?.showDialog === 'function') popup.showDialog();
    });

    label.append(trigger);
    return true;
  };

  const start = () => {
    const observer = new MutationObserver(() => {
      placeTrigger();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    placeTrigger();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
